import { useContext } from 'react'
import FeatureFlagContext from '@lib/feature-flags/FeatureFlagContext'
import { isGolfFacilitiesDataSourceEnabled } from './facility-rollout'

/** Client-side gate matching `isGolfFacilitiesDataSourceEnabled` (datasource flag only). */
export default function useGolfFacilitiesDataSourceEnabled() {
  const featureFlags = useContext(FeatureFlagContext)
  return isGolfFacilitiesDataSourceEnabled(featureFlags)
}
